/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimCenterBookable } from './ClaimCenterBookable';
import {
    ClaimCenterBookableFromJSON,
    ClaimCenterBookableFromJSONTyped,
    ClaimCenterBookableToJSON,
} from './ClaimCenterBookable';
import type { ClaimCenterBookableSchedule } from './ClaimCenterBookableSchedule';
import {
    ClaimCenterBookableScheduleFromJSON,
    ClaimCenterBookableScheduleFromJSONTyped,
    ClaimCenterBookableScheduleToJSON,
} from './ClaimCenterBookableSchedule';

/**
 * 
 * @export
 * @interface ClaimCenterBookableAndSchedule
 */
export interface ClaimCenterBookableAndSchedule {
    /**
     * 
     * @type {Array<ClaimCenterBookableSchedule>}
     * @memberof ClaimCenterBookableAndSchedule
     */
    schedules: Array<ClaimCenterBookableSchedule>;
    /**
     * 
     * @type {ClaimCenterBookable}
     * @memberof ClaimCenterBookableAndSchedule
     */
    bookable: ClaimCenterBookable;
}

/**
 * Check if a given object implements the ClaimCenterBookableAndSchedule interface.
 */
export function instanceOfClaimCenterBookableAndSchedule(value: object): value is ClaimCenterBookableAndSchedule {
    if (!('schedules' in value) || value['schedules'] === undefined) return false;
    if (!('bookable' in value) || value['bookable'] === undefined) return false;
    return true;
}

export function ClaimCenterBookableAndScheduleFromJSON(json: any): ClaimCenterBookableAndSchedule {
    return ClaimCenterBookableAndScheduleFromJSONTyped(json, false);
}

export function ClaimCenterBookableAndScheduleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCenterBookableAndSchedule {
    if (json == null) {
        return json;
    }
    return {
        
        'schedules': ((json['schedules'] as Array<any>).map(ClaimCenterBookableScheduleFromJSON)),
        'bookable': ClaimCenterBookableFromJSON(json['bookable']),
    };
}

export function ClaimCenterBookableAndScheduleToJSON(value?: ClaimCenterBookableAndSchedule | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'schedules': ((value['schedules'] as Array<any>).map(ClaimCenterBookableScheduleToJSON)),
        'bookable': ClaimCenterBookableToJSON(value['bookable']),
    };
}

